import { useState, useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";

export default function OnboardingNotification() {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const wasDismissed = localStorage.getItem(
      "onboarding_notification_dismissed",
    );
    if (wasDismissed === "true") {
      setIsVisible(false);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem("onboarding_notification_dismissed", "true");
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`
        fixed top-20 right-4 z-[9999]
        max-w-xs sm:max-w-sm
        transition-all duration-300 ease-in-out
        ${
          isClosing
            ? "opacity-0 translate-x-8 scale-95"
            : "opacity-100 translate-x-0 scale-100"
        }
      `}
    >
      {/* Cloud-like bubble */}
      <div
        className={`
          relative
          rounded-3xl
          p-5 pr-12
          shadow-2xl
          backdrop-blur-sm
          ${
            theme === "light"
              ? "bg-gradient-to-br from-teal-50 to-emerald-50 border border-teal-200"
              : "bg-gradient-to-br from-emerald-900/90 to-teal-900/90 border border-emerald-700"
          }
        `}
      >
        {/* Icon */}
        <div
          className={`
          w-10 h-10 rounded-full mb-3
          flex items-center justify-center
          ${theme === "light" ? "bg-teal-100" : "bg-emerald-800/50"}
        `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`w-6 h-6 ${theme === "light" ? "text-teal-700" : "text-emerald-300"}`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
            />
          </svg>
        </div>

        {/* Content */}
        <div className="space-y-2">
          <h3
            className={`
            text-sm font-bold
            ${theme === "light" ? "text-teal-900" : "text-emerald-100"}
          `}
          >
            Welcome to Ascendra! ✨
          </h3>
          <p
            className={`
            text-xs leading-relaxed
            ${theme === "light" ? "text-teal-800" : "text-emerald-200"}
          `}
          >
            We are initiating your Ascendra experience. For onboarding, the more information you provide, the better we can help you later!
          </p>
        </div>

        {/* Close button */}
        <button
          onClick={handleClose}
          className={`
            absolute top-3 right-3
            w-8 h-8 rounded-full
            flex items-center justify-center
            transition-all duration-200
            ${
              theme === "light"
                ? "hover:bg-teal-100 active:bg-teal-200 text-teal-700"
                : "hover:bg-emerald-800/50 active:bg-emerald-700/50 text-emerald-300"
            }
          `}
          aria-label="Close notification"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
